<app-menu></app-menu>

<section class="controlhelp-page" *ngIf="tenantId; else emptyState">
  <div class="page-guide">CONTROLPS / CONTROLHELP</div>

  <div class="tab-toolbar">
    <div class="cp-tabs controlhelp-main-tabs">
      <button
        mat-stroked-button
        type="button"
        *ngIf="canManageControlhelp"
        [class.active]="selectedTab === 'dashboard'"
        (click)="selectMainTab('dashboard')">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
      </button>
      <button mat-stroked-button type="button" [class.active]="selectedTab === 'tickets'" (click)="selectMainTab('tickets')">
        <mat-icon>confirmation_number</mat-icon>
        <span>Tickets</span>
      </button>
      <button
        mat-stroked-button
        type="button"
        [class.active]="selectedTab === 'categories'"
        (click)="selectMainTab('categories')"
        *ngIf="controlhelpSectorEnabled">
        <mat-icon>category</mat-icon>
        <span>Categorias</span>
      </button>
      <button
        mat-stroked-button
        type="button"
        [class.active]="selectedTab === 'sla'"
        (click)="selectMainTab('sla')"
        *ngIf="controlhelpSectorEnabled">
        <mat-icon>schedule</mat-icon>
        <span>SLA</span>
      </button>
    </div>

    <div class="tab-toolbar__actions">
      <button mat-raised-button color="primary" class="quick-actions-btn" type="button" [matMenuTriggerFor]="helpActionsMenu">
        <mat-icon>add</mat-icon>
        <span class="quick-actions-btn__label">Ações</span>
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #helpActionsMenu="matMenu" xPosition="before" yPosition="below">
        <button mat-menu-item type="button" (click)="openNewTicket()">
          <mat-icon>confirmation_number</mat-icon>
          <span>Abrir chamado</span>
        </button>
        <button mat-menu-item type="button" (click)="openCategoryModal()" *ngIf="controlhelpSectorEnabled">
          <mat-icon>category</mat-icon>
          <span>Nova categoria</span>
        </button>
        <button mat-menu-item type="button" (click)="openSlaModal()" *ngIf="controlhelpSectorEnabled">
          <mat-icon>schedule</mat-icon>
          <span>Novo SLA</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="page-feedback" *ngIf="pageFeedback" [class.error]="pageFeedback.type === 'error'">
    <span>{{ pageFeedback.message }}</span>
    <button type="button" (click)="pageFeedback = null">&times;</button>
  </div>

  <section class="summary-grid" *ngIf="selectedTab === 'tickets'">
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Em aberto</span>
        <mat-icon>mark_email_unread</mat-icon>
      </div>
      <strong>{{ ticketsByStatus('OPEN') }}</strong>
      <small>Tickets aguardando tratativa</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Em andamento</span>
        <mat-icon>pending_actions</mat-icon>
      </div>
      <strong>{{ ticketsByStatus('IN_PROGRESS') }}</strong>
      <small>Tickets em execução</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Aguardando</span>
        <mat-icon>hourglass_top</mat-icon>
      </div>
      <strong>{{ ticketsByStatus('WAITING_USER') + ticketsByStatus('WAITING_THIRD_PARTY') }}</strong>
      <small>Dependência de usuário/terceiros</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Resolvidos</span>
        <mat-icon>task_alt</mat-icon>
      </div>
      <strong>{{ ticketsByStatus('RESOLVED') }}</strong>
      <small>Finalizados com sucesso</small>
    </article>
  </section>

  <section class="dashboard-v2-kpis" *ngIf="selectedTab === 'dashboard' && canManageControlhelp">
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Em aberto</span>
        <mat-icon>mark_email_unread</mat-icon>
      </div>
      <strong>{{ dashboardOpenCount }}</strong>
      <small>Tickets abertos do departamento</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Em andamento</span>
        <mat-icon>pending_actions</mat-icon>
      </div>
      <strong>{{ dashboardInProgressCount }}</strong>
      <small>Tickets em tratativa</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Aguardando</span>
        <mat-icon>hourglass_top</mat-icon>
      </div>
      <strong>{{ dashboardWaitingCount }}</strong>
      <small>Dependência de usuário/terceiro</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Resolvidos</span>
        <mat-icon>task_alt</mat-icon>
      </div>
      <strong>{{ dashboardResolvedCount }}</strong>
      <small>Finalizados no período</small>
    </article>
  </section>

  <section class="dashboard-v2-layout" *ngIf="selectedTab === 'dashboard' && canManageControlhelp">
    <article class="card dashboard-v2-card dashboard-v2-card--line">
      <header class="dashboard-v2-card__head">
        <h3>Evolução de chamados</h3>
        <div class="dashboard-v2-period-toggle">
          <button type="button" class="dashboard-v2-period-btn" [class.active]="dashboardPeriodMonths === 3" (click)="setDashboardPeriod(3)">3m</button>
          <button type="button" class="dashboard-v2-period-btn" [class.active]="dashboardPeriodMonths === 6" (click)="setDashboardPeriod(6)">6m</button>
          <button type="button" class="dashboard-v2-period-btn" [class.active]="dashboardPeriodMonths === 12" (click)="setDashboardPeriod(12)">12m</button>
        </div>
      </header>
      <div class="dashboard-v2-line-chart">
        <canvas
          baseChart
          class="dashboard-v2-line-chart__canvas"
          [data]="dashboardLineChartData"
          [options]="dashboardLineChartOptions"
          [type]="'line'"></canvas>
      </div>
      <div class="dashboard-v2-legend">
        <span><i class="legend-dot legend-dot--primary"></i>Abertos</span>
        <span><i class="legend-dot legend-dot--secondary"></i>Resolvidos</span>
        <span title="Média simples de tickets abertos por mês no período selecionado."><i class="legend-line legend-line--average"></i>Média {{ dashboardTicketsAverageLabel }}/mês</span>
      </div>
    </article>

    <article class="card dashboard-v2-card dashboard-v2-card--department">
      <header class="dashboard-v2-card__head">
        <h3>Distribuição por prioridade</h3>
        <span>Departamento</span>
      </header>
      <div class="dashboard-v2-donut-wrap">
        <div class="dashboard-v2-donut-chart">
          <canvas
            baseChart
            class="dashboard-v2-donut__canvas"
            [data]="dashboardPriorityDonutData"
            [options]="dashboardDonutChartOptions"
            [type]="'doughnut'"></canvas>
          <div class="dashboard-v2-donut__inner">
            <strong>{{ dashboardPriorityTop.count }}</strong>
            <small>{{ dashboardPriorityTop.label }}</small>
          </div>
        </div>
        <div class="dashboard-v2-status-bars">
          <ng-container *ngFor="let row of dashboardPriorityRows">
            <div class="dashboard-v2-status-bars__row">
              <span>{{ row.label }}</span>
              <strong>{{ row.count }} · {{ row.percent }}%</strong>
            </div>
            <div class="dashboard-v2-status-bars__track">
              <i [style.width.%]="row.percent" [style.background]="row.color"></i>
            </div>
          </ng-container>
        </div>
      </div>
    </article>

    <article class="card dashboard-v2-card dashboard-v2-card--department">
      <header class="dashboard-v2-card__head">
        <h3>Distribuição por status</h3>
        <span>Departamento</span>
      </header>
      <div class="dashboard-v2-status-bars">
        <ng-container *ngFor="let row of dashboardStatusRows">
          <div class="dashboard-v2-status-bars__row">
            <span>{{ row.label }}</span>
            <strong>{{ row.count }} · {{ row.percent }}%</strong>
          </div>
          <div class="dashboard-v2-status-bars__track">
            <i
              [style.width.%]="row.percent"
              [ngClass]="{
                'status-open': row.tone === 'open',
                'status-progress': row.tone === 'progress',
                'status-waiting': row.tone === 'waiting',
                'status-resolved': row.tone === 'resolved'
              }"></i>
          </div>
        </ng-container>
      </div>
    </article>

    <article class="card dashboard-v2-card dashboard-v2-card--department">
      <header class="dashboard-v2-card__head">
        <h3>Aberturas por departamento</h3>
        <span>Top 8</span>
      </header>
      <div class="dashboard-v2-status-bars">
        <ng-container *ngFor="let row of dashboardOpenedByDepartmentRows">
          <div class="dashboard-v2-status-bars__row">
            <span>{{ row.label }}</span>
            <strong>{{ row.count }} · {{ row.percent }}%</strong>
          </div>
          <div class="dashboard-v2-status-bars__track">
            <i [style.width.%]="row.percent"></i>
          </div>
        </ng-container>
        <p class="dashboard-v2-empty" *ngIf="!dashboardOpenedByDepartmentRows.length">Sem dados no período.</p>
      </div>
    </article>

    <article class="card dashboard-v2-card dashboard-v2-card--department">
      <header class="dashboard-v2-card__head">
        <h3>Aberturas por usuário</h3>
        <span>Top 8</span>
      </header>
      <div class="dashboard-v2-status-bars">
        <ng-container *ngFor="let row of dashboardOpenedByUserRows">
          <div class="dashboard-v2-status-bars__row">
            <span>{{ row.label }}</span>
            <strong>{{ row.count }} · {{ row.percent }}%</strong>
          </div>
          <div class="dashboard-v2-status-bars__track">
            <i [style.width.%]="row.percent"></i>
          </div>
        </ng-container>
        <p class="dashboard-v2-empty" *ngIf="!dashboardOpenedByUserRows.length">Sem dados no período.</p>
      </div>
    </article>
  </section>

  <section class="tickets-area" *ngIf="selectedTab === 'tickets'">
    <div class="cp-tabs controlhelp-view-tabs">
      <button mat-stroked-button type="button" [class.active]="ticketView === 'queue'" (click)="setTicketView('queue')" *ngIf="controlhelpSectorEnabled">
        <mat-icon>view_list</mat-icon>
        <span>Fila de chamados</span>
      </button>
      <button mat-stroked-button type="button" [class.active]="ticketView === 'mine'" (click)="setTicketView('mine')">
        <mat-icon>person</mat-icon>
        <span>Meus chamados</span>
      </button>
    </div>

    <section class="panel controlhelp-filter-panel">
      <div class="cp-form-row controlhelp-filter-row">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field controlhelp-filter-search">
          <mat-label>Pesquisar tickets</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="search"
            placeholder="Pesquisar ticket, código ou categoria"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onTicketFiltersChanged()">
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field controlhelp-filter-select">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="statusFilter" (ngModelChange)="onTicketFiltersChanged()">
            <mat-option value="ALL">Todos os status</mat-option>
            <mat-option value="OPEN">Aberto</mat-option>
            <mat-option value="IN_PROGRESS">Em andamento</mat-option>
            <mat-option value="WAITING_USER">Aguardando usuário</mat-option>
            <mat-option value="WAITING_THIRD_PARTY">Aguardando terceiro</mat-option>
            <mat-option value="RESOLVED">Resolvido</mat-option>
            <mat-option value="CLOSED">Fechado</mat-option>
            <mat-option value="CANCELED">Cancelado</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field controlhelp-filter-select">
          <mat-label>Prioridade</mat-label>
          <mat-select [(ngModel)]="priorityFilter" (ngModelChange)="onTicketFiltersChanged()">
            <mat-option value="ALL">Todas as prioridades</mat-option>
            <mat-option value="LOW">Baixa</mat-option>
            <mat-option value="MEDIUM">Média</mat-option>
            <mat-option value="HIGH">Alta</mat-option>
            <mat-option value="URGENT">Urgente</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field controlhelp-filter-select">
          <mat-label>Ordenação</mat-label>
          <mat-select [(ngModel)]="sortOrder" (ngModelChange)="onTicketFiltersChanged()">
            <mat-option value="oldest">Mais antigos</mat-option>
            <mat-option value="newest">Mais recentes</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field controlhelp-filter-select" *ngIf="ticketDepartmentFilterOptions.length">
          <mat-label>Departamento</mat-label>
          <mat-select [(ngModel)]="departmentFilter" (ngModelChange)="onTicketFiltersChanged()">
            <mat-option value="ALL">Todos os departamentos</mat-option>
            <mat-option *ngFor="let dept of ticketDepartmentFilterOptions" [value]="dept.id">
              {{ dept.sector_name ? (dept.sector_name + ' / ' + dept.name) : dept.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <div class="tickets-list">
      <article class="ticket-card" *ngFor="let ticket of pagedTickets" (click)="openTicketDetail(ticket)">
        <div class="ticket-main">
          <div class="ticket-main__left">
            <strong>{{ ticket.title }}</strong>
            <small>{{ ticket.ticket_code }} · {{ ticket.category || 'Sem categoria' }}</small>
          </div>
          <div class="ticket-main__right">
            <span class="pill" [class]="ticket.status.toLowerCase()">{{ statusLabel(ticket.status) }}</span>
            <span
              class="pill pill--department"
              *ngIf="ticket.department_name || ticket.department_id"
              [title]="departmentLabel(ticket.department_id)">
              {{ ticket.department_name || departmentLabel(ticket.department_id) }}
            </span>
          </div>
        </div>
        <div class="ticket-meta">
          <span>Aberto por: {{ creatorLabel(ticket) }}</span>
          <span>Prioridade: {{ formatPriority(ticket.priority) }}</span>
          <span [class.ticket-meta__missing]="!ticket.assigned_to">
            Responsável: {{ ticket.assigned_to_name || userNameById(ticket.assigned_to) }}
          </span>
          <span [class.ticket-meta__late]="slaResolutionLabel(ticket) === 'Fora do SLA'">
            Prazo: {{ formatDate(ticket.due_at) }}
          </span>
          <span>Atualização: {{ lastUpdateLabel(ticket) }}</span>
          <span>Aberto {{ openedDaysLabel(ticket) }}</span>
          <span>
            SLA resposta:
            <strong class="sla-badge" [ngClass]="slaBadgeClass(slaResponseLabel(ticket))">
              {{ slaResponseLabel(ticket) }}
            </strong>
          </span>
          <span>
            SLA resolução:
            <strong class="sla-badge" [ngClass]="slaBadgeClass(slaResolutionLabel(ticket))">
              {{ slaResolutionLabel(ticket) }}
            </strong>
          </span>
        </div>
      </article>
      <p class="empty" *ngIf="!filteredTickets.length">Nenhum ticket encontrado.</p>
      <div class="table-pagination" *ngIf="filteredTickets.length">
        <span>{{ ticketPageStart }}-{{ ticketPageEnd }} de {{ filteredTickets.length }}</span>
        <button type="button" (click)="prevTicketPage()" [disabled]="ticketPage <= 1">Anterior</button>
        <span>{{ ticketPage }} / {{ ticketTotalPages }}</span>
        <button type="button" (click)="nextTicketPage()" [disabled]="ticketPage >= ticketTotalPages">Próxima</button>
      </div>
    </div>
  </section>

  <section class="categories-area" *ngIf="selectedTab === 'categories'">
    <section class="panel controlhelp-filter-panel">
      <div class="cp-form-row controlhelp-filter-row">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table">
          <mat-label>Pesquisar categoria</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" [(ngModel)]="categorySearch" placeholder="Pesquisar categoria">
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table">
          <mat-label>Pesquisar subcategoria</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" [(ngModel)]="subcategorySearch" placeholder="Pesquisar subcategoria">
        </mat-form-field>
      </div>
    </section>

    <div class="category-grid">
      <article class="category-card" *ngFor="let category of filteredCategories">
        <div>
          <strong>{{ category.name }}</strong>
          <small>{{ departmentLabel(category.department_id) }}</small>
          <small *ngIf="category.subcategory">Subcategoria: {{ category.subcategory }}</small>
          <small *ngIf="!category.subcategory">{{ category.description || 'Sem descrição' }}</small>
        </div>
        <div class="category-card__actions">
          <span class="pill" [class.active]="category.active">{{ category.active ? 'Ativo' : 'Inativo' }}</span>
          <button mat-stroked-button type="button" class="card-action" (click)="openEditCategoryModal(category)">Editar</button>
        </div>
      </article>
    </div>
  </section>

  <section class="sla-area" *ngIf="selectedTab === 'sla'">
    <section class="panel controlhelp-filter-panel">
      <div class="cp-form-row controlhelp-filter-row">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table">
          <mat-label>Pesquisar prioridade</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" [(ngModel)]="slaCategorySearch" placeholder="Pesquisar prioridade">
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table">
          <mat-label>Pesquisar departamento</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" [(ngModel)]="slaSubcategorySearch" placeholder="Pesquisar departamento">
        </mat-form-field>
      </div>
    </section>

    <div class="sla-grid">
      <article class="sla-card" *ngFor="let sla of filteredSlaPolicies">
        <div>
          <strong>{{ formatPriority(sla.priority) }}</strong>
          <small>{{ departmentLabel(sla.department_id) }}</small>
          <small>Resposta: {{ sla.response_time_minutes }} min</small>
          <small>Resolução: {{ sla.resolution_time_minutes }} min</small>
        </div>
        <button mat-stroked-button type="button" class="card-action" (click)="openEditSlaModal(sla)">Editar</button>
      </article>
    </div>
  </section>

  <div class="cp-modal-backdrop modal-backdrop" *ngIf="showNewTicketModal" (click)="ticketCreateFeedbackState === 'loading' ? null : closeNewTicket()"></div>
  <section class="modal-card cp-project-ticket-modal controlhelp-ticket-modal" *ngIf="showNewTicketModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Novo chamado</h2>
        <small>Registre o chamado e anexe evidências necessárias.</small>
      </div>
      <button class="icon" type="button" [disabled]="ticketCreateFeedbackState === 'loading'" (click)="closeNewTicket()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form class="cp-modal-body" (ngSubmit)="submitTicket()">
      <div class="cp-modal-scroll">
        <div class="cp-ticket-modal-layout">
          <section class="panel cp-project-modal-panel cp-ticket-modal-main">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Título</mat-label>
              <input matInput type="text" [(ngModel)]="newTicketForm.title" name="ticket_title" required>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Descrição</mat-label>
              <textarea matInput rows="4" [(ngModel)]="newTicketForm.description" name="ticket_description" required></textarea>
            </mat-form-field>

            <div class="cp-form-row cp-ticket-grid-2">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Prioridade</mat-label>
                <mat-select [(ngModel)]="newTicketForm.priority" name="ticket_priority">
                  <mat-option value="LOW">Baixa</mat-option>
                  <mat-option value="MEDIUM">Média</mat-option>
                  <mat-option value="HIGH">Alta</mat-option>
                  <mat-option value="URGENT">Urgente</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Origem</mat-label>
                <mat-select [(ngModel)]="newTicketForm.origin_department_id" name="ticket_origin" required>
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let dept of originDepartments()" [value]="dept.id">
                    {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="cp-form-row cp-ticket-grid-3">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Departamento</mat-label>
                <mat-select [(ngModel)]="newTicketForm.department_id" name="ticket_department" required (ngModelChange)="onDepartmentChange()">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let dept of departments" [value]="dept.id">
                    {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Categoria</mat-label>
                <mat-select [(ngModel)]="newTicketForm.category" name="ticket_category" [disabled]="!newTicketForm.department_id">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let cat of categoriesByDepartment()" [value]="cat.name">{{ cat.name }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Subcategoria</mat-label>
                <mat-select [(ngModel)]="newTicketForm.subcategory" name="ticket_subcategory" [disabled]="!newTicketForm.department_id || !newTicketForm.category">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let sub of subcategoriesByDepartment()" [value]="sub">{{ sub }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </section>

          <aside class="panel cp-project-modal-panel cp-ticket-modal-side">
            <h4>Anexos</h4>
            <label
              class="dropzone full"
              [class.dragging]="draggingNewTicket"
              (dragover)="onNewTicketDragOver($event)"
              (dragleave)="onNewTicketDragLeave()"
              (drop)="onNewTicketDrop($event)">
              <input type="file" #ticketAttachmentInput (change)="onNewTicketFileSelect($event)" multiple>
              <div class="dropzone-content">
                <mat-icon>attach_file</mat-icon>
                <div>
                  <strong>Adicionar anexos</strong>
                  <span>Arraste e solte aqui ou clique para selecionar</span>
                </div>
              </div>
            </label>

            <div class="file-list" *ngIf="newTicketFiles.length">
              <div class="file-item" *ngFor="let file of newTicketFiles; let i = index">
                <span>{{ file.name }}</span>
                <button type="button" (click)="removeNewTicketFile(i)">Remover</button>
              </div>
            </div>
          </aside>
        </div>
      </div>

      <footer class="entry-footer">
        <div class="form-feedback" *ngIf="ticketFormFeedback" [class.error]="ticketFormFeedbackType === 'error'">
          {{ ticketFormFeedback }}
        </div>
        <button mat-stroked-button type="button" [disabled]="ticketCreateFeedbackState === 'loading'" (click)="closeNewTicket()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="ticketCreateFeedbackState === 'loading'">
          {{ ticketCreateFeedbackState === 'loading' ? 'Salvando...' : 'Salvar chamado' }}
        </button>
      </footer>
    </form>

    <div class="controlhelp-create-overlay" *ngIf="ticketCreateFeedbackState !== 'idle'">
      <div class="controlhelp-create-overlay__content" [ngSwitch]="ticketCreateFeedbackState">
        <ng-container *ngSwitchCase="'loading'">
          <div class="controlhelp-create-overlay__spinner">
            <img src="../../../assets/MIV/brand/versao 1.png" alt="ControlPS">
          </div>
          <strong>{{ ticketCreateFeedbackMessage || 'Criando chamado...' }}</strong>
          <small>{{ ticketCreateFeedbackDetail || 'Aguarde enquanto finalizamos o processo.' }}</small>
        </ng-container>

        <ng-container *ngSwitchCase="'success'">
          <div class="controlhelp-create-overlay__icon controlhelp-create-overlay__icon--success">✓</div>
          <strong>{{ ticketCreateFeedbackMessage || 'Chamado criado com sucesso!' }}</strong>
          <small>{{ ticketCreateFeedbackDetail }}</small>
          <button type="button" class="controlhelp-create-overlay__action-btn" (click)="dismissTicketCreateFeedback(true)">Entendi</button>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <div class="controlhelp-create-overlay__icon controlhelp-create-overlay__icon--error">!</div>
          <strong>{{ ticketCreateFeedbackMessage || 'Falha ao criar chamado' }}</strong>
          <small>{{ ticketCreateFeedbackDetail || 'Tente novamente em instantes.' }}</small>
          <button type="button" class="controlhelp-create-overlay__action-btn" (click)="dismissTicketCreateFeedback()">Entendi</button>
        </ng-container>
      </div>
    </div>
  </section>

  <div class="cp-modal-backdrop modal-backdrop" *ngIf="showTicketDetail" (click)="closeTicketDetail()"></div>
  <section class="modal-card detail-modal cp-modal-fixed-height controlhelp-detail-modal" *ngIf="showTicketDetail && activeTicket" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>{{ activeTicket.title }}</h2>
        <small>{{ activeTicket.ticket_code }} · {{ activeTicket.related_module }} · {{ ticketViewLabel() }} · {{ departmentLabel(activeTicket.department_id) }}</small>
      </div>
      <button class="icon" type="button" (click)="closeTicketDetail()" [disabled]="detailSaving">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="modal-feedback" *ngIf="detailFeedback" [class.error]="detailFeedbackType === 'error'">
      {{ detailFeedback }}
    </div>

    <div class="cp-modal-body">
      <nav class="cp-tabs cp-ticket-detail-tabs">
        <button mat-stroked-button type="button" [class.active]="ticketDetailTab === 'summary'" (click)="ticketDetailTab = 'summary'">
          <mat-icon>info</mat-icon>
          Resumo
        </button>
        <button mat-stroked-button type="button" [class.active]="ticketDetailTab === 'comments'" (click)="ticketDetailTab = 'comments'">
          <mat-icon>chat</mat-icon>
          Comentários
        </button>
        <button mat-stroked-button type="button" [class.active]="ticketDetailTab === 'history'" (click)="ticketDetailTab = 'history'">
          <mat-icon>history</mat-icon>
          Histórico
        </button>
      </nav>

      <div class="cp-modal-scroll">
        <div class="controlhelp-modal-grid controlhelp-modal-grid--detail">
          <div class="controlhelp-main">
            <section class="panel">
              <ng-container [ngSwitch]="ticketDetailTab">
                <ng-container *ngSwitchCase="'summary'">
                  <p class="ticket-description">{{ activeTicket.description }}</p>
                  <div class="controlhelp-evidence-head">
                    <strong>Evidências</strong>
                    <button mat-stroked-button color="primary" type="button" *ngIf="canEditActiveTicket()" (click)="attachmentInputV2.click()">Adicionar</button>
                    <input #attachmentInputV2 type="file" (change)="addAttachment($event)" hidden>
                  </div>
                  <div class="v2-attachments" *ngIf="standaloneAttachments().length; else noAttachmentsV2">
                    <div class="v2-attachment-card" *ngFor="let file of standaloneAttachments()">
                      <div class="file-thumb" [class.file-thumb--placeholder]="!isImageAttachment(file)">
                        <img *ngIf="isImageAttachment(file)" [src]="fileUrl(file)" [alt]="file.file_name">
                        <mat-icon *ngIf="!isImageAttachment(file)">{{ isPdfAttachment(file) ? 'picture_as_pdf' : 'insert_drive_file' }}</mat-icon>
                      </div>
                      <div class="file-info">
                        <div class="file-name">{{ formatAttachmentName(file.file_name) }}</div>
                        <div class="file-meta">
                          {{ file.uploaded_by_name || userNameById(file.uploaded_by) }} · {{ file.uploaded_at | date:'short' }}
                          · {{ file.file_size ? (file.file_size / 1024 | number:'1.0-0') + ' KB' : '—' }}
                        </div>
                      </div>
                      <a mat-icon-button [href]="fileUrl(file)" target="_blank">
                        <mat-icon>open_in_new</mat-icon>
                      </a>
                    </div>
                  </div>
                  <ng-template #noAttachmentsV2>
                    <p class="text-muted">Nenhum anexo.</p>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'comments'">
                  <form class="comment-form" (ngSubmit)="addComment()">
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field w-100">
                      <mat-label>Comentário</mat-label>
                      <textarea matInput rows="4" [(ngModel)]="newCommentForm.comment" name="new_comment_v2" placeholder="Adicionar comentário"></textarea>
                    </mat-form-field>
                    <div class="d-flex flex-wrap gap-2 align-items-center">
                      <mat-slide-toggle *ngIf="canCreateInternalComment()" [(ngModel)]="newCommentForm.is_internal" name="internal_comment_v2">Comentário interno</mat-slide-toggle>
                      <button mat-stroked-button type="button" (click)="commentAttachmentInputV2.click()">Anexar arquivo</button>
                      <input #commentAttachmentInputV2 type="file" (change)="onCommentFileSelected($event)" hidden>
                      <button mat-raised-button color="primary" type="submit">Enviar comentário</button>
                    </div>
                  </form>
                  <mat-divider class="my-3"></mat-divider>
                  <div *ngIf="ticketComments.length; else noCommentsV2" class="comment-timeline">
                    <article *ngFor="let comment of ticketComments" class="comment-timeline-item" [class.comment-timeline-item--internal]="comment.is_internal">
                      <div class="comment-timeline-item__rail">
                        <span class="comment-timeline-item__dot">
                          <mat-icon>{{ comment.is_internal ? 'lock' : 'chat_bubble' }}</mat-icon>
                        </span>
                        <span class="comment-timeline-item__line"></span>
                      </div>
                      <div class="comment-timeline-item__content">
                        <div class="comment-timeline-item__head">
                          <div class="comment-timeline-item__title-wrap">
                            <strong class="comment-timeline-item__author">{{ comment.user_name || userNameById(comment.user_id) }}</strong>
                          </div>
                          <span class="comment-timeline-item__date">{{ comment.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
                        </div>
                        <div class="comment-timeline-item__body">{{ comment.comment }}</div>
                        <span *ngIf="comment.is_internal" class="comment-internal-badge">
                          <mat-icon>lock</mat-icon>
                          Interno
                        </span>
                        <div class="comment-attachments" *ngIf="commentAttachments(comment.id).length">
                          <div class="comment-attachment" *ngFor="let file of commentAttachments(comment.id)">
                            <div class="file-thumb file-thumb--sm" [class.file-thumb--placeholder]="!isImageAttachment(file)">
                              <img *ngIf="isImageAttachment(file)" [src]="fileUrl(file)" [alt]="file.file_name">
                              <mat-icon *ngIf="!isImageAttachment(file)">{{ isPdfAttachment(file) ? 'picture_as_pdf' : 'insert_drive_file' }}</mat-icon>
                            </div>
                            <div class="comment-attachment__meta">
                              <a [href]="fileUrl(file)" target="_blank">{{ formatAttachmentName(file.file_name, 46) }}</a>
                              <small>{{ file.uploaded_at | date:'short' }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                  <ng-template #noCommentsV2>
                    <p class="text-muted">Nenhum comentário ainda.</p>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'history'">
                  <div class="ticket-history-timeline" *ngIf="ticketHistory.length; else noHistoryV2">
                    <article class="ticket-history-item" *ngFor="let item of ticketHistory; let first = first" [class.ticket-history-item--first]="first">
                      <div class="ticket-history-item__rail">
                            <span class="ticket-history-item__dot" [ngClass]="'tone-' + historyTone(item)">
                          <mat-icon>{{ historyIcon(item) }}</mat-icon>
                        </span>
                        <span class="ticket-history-item__line"></span>
                      </div>
                      <div class="ticket-history-item__content">
                        <header class="ticket-history-item__head">
                          <div class="ticket-history-item__title-wrap">
                            <strong class="ticket-history-item__title">{{ historyLabel(item) }}</strong>
                            <span class="ticket-history-item__badge" [ngClass]="'tone-' + historyTone(item)">{{ historyActionTag(item) }}</span>
                          </div>
                          <span class="ticket-history-item__date">{{ item.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
                        </header>
                        <p class="ticket-history-item__detail" *ngIf="historyDetail(item)">{{ historyDetail(item) }}</p>
                        <footer class="ticket-history-item__meta">
                          <mat-icon>person</mat-icon>
                          <span>{{ item.user_name || userNameById(item.user_id) }}</span>
                        </footer>
                      </div>
                    </article>
                  </div>
                  <ng-template #noHistoryV2>
                    <p class="text-muted">No history available.</p>
                  </ng-template>
                </ng-container>
              </ng-container>
            </section>
          </div>

          <aside class="controlhelp-side">
            <section class="panel panel-collapsible">
              <header class="panel-collapsible__header" (click)="toggleDetailPanel('summary')">
                <h3>Resumo</h3>
                <button type="button" class="panel-collapsible__toggle">
                  <mat-icon>{{ detailPanelOpen.summary ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </header>
              <div class="panel-collapsible__body" *ngIf="detailPanelOpen.summary">
                <div class="controlhelp-summary-list">
                  <div><strong>Código</strong><span>{{ activeTicket.ticket_code }}</span></div>
                  <div><strong>Categoria</strong><span>{{ activeTicket.category || '—' }}</span></div>
                  <div><strong>Subcategoria</strong><span>{{ activeTicket.subcategory || '—' }}</span></div>
                  <div><strong>Aberto por</strong><span>{{ activeTicket.created_by_name || userNameById(activeTicket.created_by) }}</span></div>
                  <div><strong>Abertura</strong><span>{{ activeTicket.opened_at | date:'dd/MM/yyyy HH:mm' }}</span></div>
                  <div><strong>Início do atendimento</strong><span>{{ firstInProgressLabel(activeTicket) }}</span></div>
                  <div><strong>Conclusão</strong><span>{{ resolvedAtLabel(activeTicket) }}</span></div>
                  <div><strong>Tempo até iniciar</strong><span>{{ timeToStartLabel(activeTicket) }}</span></div>
                  <div><strong>Tempo de atendimento</strong><span>{{ handlingTimeLabel(activeTicket) }}</span></div>
                  <div><strong>Tempo total</strong><span>{{ timeToResolveLabel(activeTicket) }}</span></div>
                </div>
                <div class="controlhelp-summary-chips">
                  <span class="controlhelp-priority-chip">{{ statusLabel(activeTicket.status) }}</span>
                  <span class="controlhelp-priority-chip">{{ formatPriority(activeTicket.priority) }}</span>
                </div>
              </div>
            </section>

            <section class="panel panel-collapsible">
              <header class="panel-collapsible__header" (click)="toggleDetailPanel('statusPriority')">
                <h3>Status e prioridade</h3>
                <button type="button" class="panel-collapsible__toggle">
                  <mat-icon>{{ detailPanelOpen.statusPriority ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </header>
              <div class="panel-collapsible__body" *ngIf="detailPanelOpen.statusPriority">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field w-100">
                  <mat-label>Status</mat-label>
                  <select matNativeControl [(ngModel)]="detailDraft.status" name="detail_status_v2" [disabled]="!canEditActiveTicket() || detailSaving">
                    <option value="OPEN">Aberto</option>
                    <option value="IN_PROGRESS">Em andamento</option>
                    <option value="WAITING_USER">Aguardando usuário</option>
                    <option value="WAITING_THIRD_PARTY">Aguardando terceiro</option>
                    <option value="RESOLVED">Resolvido</option>
                    <option value="CLOSED">Fechado</option>
                    <option value="CANCELED">Cancelado</option>
                  </select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field w-100">
                  <mat-label>Prioridade</mat-label>
                  <select matNativeControl [(ngModel)]="detailDraft.priority" name="detail_priority_v2" [disabled]="!canEditAssigneeAndPriority() || detailSaving">
                    <option value="LOW">Baixa</option>
                    <option value="MEDIUM">Média</option>
                    <option value="HIGH">Alta</option>
                    <option value="URGENT">Urgente</option>
                  </select>
                </mat-form-field>
              </div>
            </section>

            <section class="panel panel-collapsible">
              <header class="panel-collapsible__header" (click)="toggleDetailPanel('assigneeDue')">
                <h3>Responsável e prazo</h3>
                <button type="button" class="panel-collapsible__toggle">
                  <mat-icon>{{ detailPanelOpen.assigneeDue ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </header>
              <div class="panel-collapsible__body" *ngIf="detailPanelOpen.assigneeDue">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field w-100">
                  <mat-label>Responsável</mat-label>
                  <mat-select
                    [(ngModel)]="detailDraft.assigned_to"
                    name="detail_assigned_v2"
                    panelClass="controlhelp-people-select-panel"
                    [disableOptionCentering]="true"
                    [disabled]="!canEditAssigneeAndPriority() || detailSaving"
                    (openedChange)="onAssigneeSelectOpened($event)"
                  >
                    <mat-option class="controlhelp-select-search-option" [disabled]="true">
                      <div class="controlhelp-select-search-box" (click)="$event.stopPropagation()">
                        <mat-icon>search</mat-icon>
                        <input
                          #assigneeSearchInput
                          type="search"
                          [(ngModel)]="assigneeSearch"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Pesquisar responsável"
                          aria-label="Pesquisar responsável"
                          (click)="$event.stopPropagation()"
                          (keydown)="$event.stopPropagation()"
                        >
                      </div>
                    </mat-option>
                    <mat-option value="">Sem responsável</mat-option>
                    <mat-option *ngFor="let user of filteredAssigneeUsers()" [value]="user.id + ''">{{ user.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field w-100 controlhelp-due-date-field">
                  <mat-label>Prazo</mat-label>
                  <input
                    matInput
                    [matDatepicker]="detailDuePicker"
                    [(ngModel)]="detailDueAtModel"
                    (dateChange)="onDueAtPickerChange($event.value)"
                    name="detail_due_at_v2"
                    placeholder="dd/mm/aaaa"
                    [disabled]="!canEditActiveTicket() || detailSaving"
                  >
                  <mat-datepicker-toggle matSuffix [for]="detailDuePicker"></mat-datepicker-toggle>
                  <mat-datepicker #detailDuePicker></mat-datepicker>
                </mat-form-field>
              </div>
            </section>

            <section class="panel panel-collapsible" *ngIf="canEditActiveTicket()">
              <header class="panel-collapsible__header" (click)="toggleDetailPanel('watchers')">
                <h3>Observadores</h3>
                <button type="button" class="panel-collapsible__toggle">
                  <mat-icon>{{ detailPanelOpen.watchers ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </header>
              <div class="panel-collapsible__body" *ngIf="detailPanelOpen.watchers">
                <mat-chip-set>
                  <mat-chip *ngFor="let watcher of ticketWatchers" [removable]="!detailSaving" (removed)="removeWatcher(watcher.user_id)">
                    {{ watcherLabel(watcher) }}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                </mat-chip-set>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field w-100 mt-2">
                  <mat-label>Adicionar observador</mat-label>
                  <mat-select
                    [(ngModel)]="selectedWatcherId"
                    (ngModelChange)="addWatcher($event)"
                    name="detail_add_watcher_v2"
                    panelClass="controlhelp-people-select-panel"
                    [disableOptionCentering]="true"
                    [disabled]="detailSaving"
                    (openedChange)="onWatcherSelectOpened($event)"
                  >
                    <mat-option class="controlhelp-select-search-option" [disabled]="true">
                      <div class="controlhelp-select-search-box" (click)="$event.stopPropagation()">
                        <mat-icon>search</mat-icon>
                        <input
                          #watcherSearchInput
                          type="search"
                          [(ngModel)]="watcherSearch"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Pesquisar observador"
                          aria-label="Pesquisar observador"
                          (click)="$event.stopPropagation()"
                          (keydown)="$event.stopPropagation()"
                        >
                      </div>
                    </mat-option>
                    <mat-option value="">Adicionar observador</mat-option>
                    <mat-option *ngFor="let user of watchersAvailableUsers()" [value]="user.id">{{ user.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </section>
          </aside>
        </div>
      </div>
    </div>
    <footer class="controlhelp-detail-actions">
      <span class="controlhelp-detail-actions__pending" *ngIf="hasPendingDetailChanges()">
        Alterações ainda não salvas
      </span>
      <button mat-stroked-button type="button" (click)="discardDetailChanges()" [disabled]="!hasPendingDetailChanges() || detailSaving">
        Descartar
      </button>
      <button mat-raised-button color="primary" type="button" (click)="saveTicketDetailChanges()" [disabled]="!hasPendingDetailChanges() || detailSaving">
        <mat-icon>{{ detailSaving ? 'hourglass_top' : 'save' }}</mat-icon>
        {{ detailSaving ? 'Salvando...' : 'Salvar alterações' }}
      </button>
    </footer>
  </section>

  <div class="cp-modal-backdrop modal-backdrop" *ngIf="showNewCategoryModal" (click)="closeCategoryModal()"></div>
  <section class="modal-card controlhelp-mini-modal" *ngIf="showNewCategoryModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Nova categoria</h2>
        <small>Cadastre categorias para classificação de tickets.</small>
      </div>
      <button class="icon" type="button" (click)="closeCategoryModal()"><mat-icon>close</mat-icon></button>
    </header>

    <form class="cp-modal-body" (ngSubmit)="submitCategory()">
      <div class="cp-modal-scroll">
        <section class="panel">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Departamento</mat-label>
              <mat-select [(ngModel)]="newCategoryForm.department_id" name="category_department" required [disabled]="!isMasterUser">
                <mat-option value="">Selecione um departamento</mat-option>
                <mat-option *ngFor="let dept of departmentsForCadastros()" [value]="dept.id">
                  {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Categoria</mat-label>
              <input matInput [(ngModel)]="newCategoryForm.name" name="category_name" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Subcategoria</mat-label>
              <input matInput [(ngModel)]="newCategoryForm.subcategory" name="category_subcategory">
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Descrição</mat-label>
            <textarea matInput rows="4" [(ngModel)]="newCategoryForm.description" name="category_desc"></textarea>
          </mat-form-field>
          <div class="cp-field-controls">
            <mat-slide-toggle [(ngModel)]="newCategoryForm.active" name="category_active">Categoria ativa</mat-slide-toggle>
          </div>
        </section>
      </div>

      <footer class="entry-footer">
        <button mat-stroked-button type="button" (click)="closeCategoryModal()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit">Salvar categoria</button>
      </footer>
    </form>
  </section>

  <div class="cp-modal-backdrop modal-backdrop" *ngIf="showEditCategoryModal" (click)="closeEditCategoryModal()"></div>
  <section class="modal-card controlhelp-mini-modal" *ngIf="showEditCategoryModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Editar categoria</h2>
        <small>Ajuste categoria e subcategoria para novos chamados.</small>
      </div>
      <button class="icon" type="button" (click)="closeEditCategoryModal()"><mat-icon>close</mat-icon></button>
    </header>

    <form class="cp-modal-body" (ngSubmit)="submitCategoryEdit()">
      <div class="cp-modal-scroll">
        <section class="panel">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Departamento</mat-label>
              <mat-select [(ngModel)]="editCategoryForm.department_id" name="edit_category_department" required [disabled]="!isMasterUser">
                <mat-option value="">Selecione um departamento</mat-option>
                <mat-option *ngFor="let dept of departmentsForCadastros()" [value]="dept.id">
                  {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Categoria</mat-label>
              <input matInput [(ngModel)]="editCategoryForm.name" name="edit_category_name" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Subcategoria</mat-label>
              <input matInput [(ngModel)]="editCategoryForm.subcategory" name="edit_category_subcategory">
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Descrição</mat-label>
            <textarea matInput rows="4" [(ngModel)]="editCategoryForm.description" name="edit_category_desc"></textarea>
          </mat-form-field>
          <div class="cp-field-controls">
            <mat-slide-toggle [(ngModel)]="editCategoryForm.active" name="edit_category_active">Categoria ativa</mat-slide-toggle>
          </div>
        </section>
      </div>

      <footer class="entry-footer">
        <button mat-stroked-button type="button" (click)="closeEditCategoryModal()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit">Salvar alterações</button>
      </footer>
    </form>
  </section>

  <div class="cp-modal-backdrop modal-backdrop" *ngIf="showNewSlaModal" (click)="closeSlaModal()"></div>
  <section class="modal-card controlhelp-mini-modal" *ngIf="showNewSlaModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Novo SLA</h2>
        <small>Defina prazos de resposta e resolução por prioridade.</small>
      </div>
      <button class="icon" type="button" (click)="closeSlaModal()"><mat-icon>close</mat-icon></button>
    </header>

    <form class="cp-modal-body" (ngSubmit)="submitSla()">
      <div class="cp-modal-scroll">
        <section class="panel">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Departamento</mat-label>
              <mat-select [(ngModel)]="newSlaForm.department_id" name="sla_department" required [disabled]="!isMasterUser">
                <mat-option value="">Selecione um departamento</mat-option>
                <mat-option *ngFor="let dept of departmentsForCadastros()" [value]="dept.id">
                  {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Prioridade</mat-label>
              <mat-select [(ngModel)]="newSlaForm.priority" name="sla_priority">
                <mat-option value="LOW">Baixa</mat-option>
                <mat-option value="MEDIUM">Média</mat-option>
                <mat-option value="HIGH">Alta</mat-option>
                <mat-option value="URGENT">Urgente</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tempo de resposta (min)</mat-label>
              <input matInput type="number" [(ngModel)]="newSlaForm.response_time_minutes" name="sla_response">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tempo de resolução (min)</mat-label>
              <input matInput type="number" [(ngModel)]="newSlaForm.resolution_time_minutes" name="sla_resolution">
            </mat-form-field>
          </div>
        </section>
      </div>

      <footer class="entry-footer">
        <button mat-stroked-button type="button" (click)="closeSlaModal()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit">Salvar SLA</button>
      </footer>
    </form>
  </section>

  <div class="cp-modal-backdrop modal-backdrop" *ngIf="showEditSlaModal" (click)="closeEditSlaModal()"></div>
  <section class="modal-card controlhelp-mini-modal" *ngIf="showEditSlaModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Editar SLA</h2>
        <small>Ajuste os tempos conforme o processo do departamento.</small>
      </div>
      <button class="icon" type="button" (click)="closeEditSlaModal()"><mat-icon>close</mat-icon></button>
    </header>

    <form class="cp-modal-body" (ngSubmit)="submitSlaEdit()">
      <div class="cp-modal-scroll">
        <section class="panel">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Departamento</mat-label>
              <mat-select [(ngModel)]="editSlaForm.department_id" name="edit_sla_department" required [disabled]="!isMasterUser">
                <mat-option value="">Selecione um departamento</mat-option>
                <mat-option *ngFor="let dept of departmentsForCadastros()" [value]="dept.id">
                  {{ dept.sector_name ? dept.sector_name + ' / ' + dept.name : dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Prioridade</mat-label>
              <mat-select [(ngModel)]="editSlaForm.priority" name="edit_sla_priority">
                <mat-option value="LOW">Baixa</mat-option>
                <mat-option value="MEDIUM">Média</mat-option>
                <mat-option value="HIGH">Alta</mat-option>
                <mat-option value="URGENT">Urgente</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tempo de resposta (min)</mat-label>
              <input matInput type="number" [(ngModel)]="editSlaForm.response_time_minutes" name="edit_sla_response" min="1">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tempo de resolução (min)</mat-label>
              <input matInput type="number" [(ngModel)]="editSlaForm.resolution_time_minutes" name="edit_sla_resolution" min="1">
            </mat-form-field>
          </div>
        </section>
      </div>

      <footer class="entry-footer">
        <button mat-stroked-button type="button" (click)="closeEditSlaModal()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit">Salvar alterações</button>
      </footer>
    </form>
  </section>

  <div class="cp-modal-backdrop modal-backdrop" *ngIf="showGuideModal" (click)="closeGuideModal()"></div>
  <section class="modal-card controlhelp-guide-modal" *ngIf="showGuideModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Guia rápido do ControlHelp</h2>
        <small>Passos iniciais para configurar a operação.</small>
      </div>
      <button class="icon" type="button" (click)="closeGuideModal()"><mat-icon>close</mat-icon></button>
    </header>

    <div class="cp-modal-body">
      <div class="cp-modal-scroll">
        <section class="panel">
          <div class="guide-steps">
            <article class="guide-step" *ngFor="let step of guideSteps; let idx = index">
              <span class="step-index">{{ idx + 1 }}</span>
              <div>
                <strong>{{ step.title }}</strong>
                <small>{{ step.description }}</small>
              </div>
            </article>
          </div>
        </section>
      </div>
      <footer class="entry-footer">
        <button mat-stroked-button type="button" (click)="openGuideTab('categories'); closeGuideModal()">Ir para categorias</button>
        <button mat-stroked-button type="button" (click)="openGuideTab('sla'); closeGuideModal()">Configurar SLA</button>
        <button mat-raised-button color="primary" type="button" (click)="openGuideTab('tickets'); closeGuideModal()">Abrir ticket</button>
      </footer>
    </div>
  </section>
</section>

<ng-template #emptyState>
  <section class="empty-state-full">
    <p>Faça login para acessar o ControlHelp.</p>
  </section>
</ng-template>
